import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { EditorToolbar, WysiwygInPlaceEditor, WysiwygProvider } from '../../publisher/wysiwyg/WysiwygInPlaceEditor';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
const WysiwygTitle = ({ showTitle, editData, configId, disabled, content, }) => {
    if (showTitle) {
        return (_jsx(Box, { sx: { mt: 1, flex: 'auto' }, children: (editData && editData.activeConfigId === configId && !disabled) ? (_jsx(WysiwygInPlaceEditor, { id: configId })) : (_jsx(WysiwygViewer, { id: configId, value: content.slate })) }));
    }
    return null;
};
WysiwygTitle.IpeWrapper = ({ configId, config, editData, children, }) => {
    if (!editData || editData.activeConfigId !== configId) {
        return children;
    }
    return (_jsx(WysiwygProvider, { id: configId, value: config.props.content ? config.props.content.slate : null, setValue: (newValue) => {
            const newContent = {
                slate: newValue,
                html: null, // serialize(newValue),
            };
            editData.actions.updateConfigValue(configId, 'props.content', newContent);
        }, children: children }));
};
WysiwygTitle.ipeControls = (_jsx(EditorToolbar, {}));
export default WysiwygTitle;
//# sourceMappingURL=WysiwygTitle.js.map